export default __webpack_public_path__ + "static/media/LogoSuperintendencia.01dff80b.svg";